import { observable, action, runInAction } from 'mobx';
import { backendServer, backendServerInvestor } from '../../variable';
import { get, post } from '../../utils/fetch';
import { errorHandler } from '../../utils/methods';

class TradeStore {
  @observable
  isLoading = false;

  @observable
  recycleInfo = {}; //订单信息

  @observable
  sellInfo = {}; // 出售信息

  @observable
  isSellOpen = false; // 自由市场是否开放

  /**
   * 获取回收电站的信息
   * @param {Object} recycleInfo 回收电站的信息
   */
  @action
  updateRecycleInfo = (recycleInfo) => {
    this.recycleInfo = recycleInfo;
  };

  /**
   * 支付
   */
  @action
  reqPay = async ({ productId, componentNum }) => {
    runInAction(() => {
      this.isLoading = true;
    });
    try {
      const response = await post(
        `${backendServer}/agentBuyBackOperating/processBuyBack`,
        {
          productId,
          componentNum
        }
      );
      runInAction(() => {
        this.isLoading = false;
      });
      return response;
    } catch (err) {
      runInAction(() => {
        this.isLoading = false;
      });
      return errorHandler(err, '支付');
    }
  };

  /**
   * 验证支付是否完成
   * @param {number} outTradeNo 订单id?
   */
  @action
  reqVerifyPay = async ({ outTradeNo }) => {
    runInAction(() => {
      this.isLoading = true;
    });
    try {
      const response = await post(
        `${backendServer}/agent/recharge/b2b/front/notify`,
        { outTradeNo }
      );
      runInAction(() => {
        this.isLoading = false;
      });
      return response;
    } catch (err) {
      runInAction(() => {
        this.isLoading = false;
      });
      return errorHandler(err, '验证支付');
    }
  };


  /**
   * 获取自由市场是否开放
   */
  @action
  getMarketPeriod = async () => {
    const url = `${backendServerInvestor}/market/v1/period`;
    try {
      const response = await get(url, {});
      if (response.success) {
        runInAction(() => {
          this.isSellOpen = response.data || false;
          if (this.isSellOpen) console.log('自由市场开放中...');
          else console.log('自由市场已关闭！');
        });
      }
      return response;
    } catch (err) {
      return errorHandler(err, '自由市场开放');
    }
  };

  /**
   * 获取待出售组件信息
   * @param sellInfo: {number} id 出售组件orderId
   * @returns {Promise<*>}: {number} componentGuidePrice 指导价
   *                        {number} availableShare 可出售数量
   */
  @action
  getSellInfo = async sellInfo => {
    runInAction(() => {
      this.isLoading = true;
    });
    try {
      const response = await get(`${backendServer}/agent/sell/record/getSellConfirmPageInfo`, {
        recordId: sellInfo.id
      });
      runInAction(() => {
        const data = response.data;
        this.sellInfo = {
          ...sellInfo,
          ...data,
          unitPrice: data.componentGuidePrice,
          componentCount: data.availableShare
        };
        this.isLoading = false;
      });
      return response;
    } catch (err) {
      runInAction(() => {
        this.isLoading = false;
      });
      return errorHandler(err, '待出售组件信息');
    }
  };

  @action
  updateSellInfoPrice = unitPrice => {
    this.sellInfo = {
      ...this.sellInfo,
      unitPrice
    };
  };

  @action
  updateSellInfoCount = componentCount => {
    this.sellInfo = {
      ...this.sellInfo,
      componentCount
    };
  };

  /**
   * 出售请求
   * @param {number} unitPrice 出售单价
   * @param {number} componentCount 出售数量
   * @param {number} id 出售组件orderId
   * @returns {Promise<*>}
   */
  @action
  requireSell = async ({ id, componentCount, unitPrice }) => {
    runInAction(() => {
      this.isLoading = true;
    });
    try {
      const response = await post(`${backendServer}/agentBuyBackOperating/sell`, {
        buybackRecordId: id, componentNum: componentCount, unitPrice: (unitPrice * 100).toFixed(0), type: 1
      });
      runInAction(() => {
        this.isLoading = false;
      });
      return response;
    } catch (err) {
      runInAction(() => {
        this.isLoading = false;
      });
      return errorHandler(err, '出售');
    }
  };

  /**
   * 撤销出售请求
   * @param {number} productId
   * @returns {Promise<*>}
   */
  @action
  requireRevoke = async productId => {
    runInAction(() => {
      this.isLoading = true;
    });
    try {
      const response = await post(`${backendServer}/agent/sell/record/cancelSell`, { productId });
      runInAction(() => {
        this.isLoading = false;
      });
      return response;
    } catch (err) {
      runInAction(() => {
        this.isLoading = false;
      });
      return errorHandler(err, '撤销出售');
    }
  };
}

const tradeStore = new TradeStore();
export default tradeStore;



// WEBPACK FOOTER //
// ./src/stores/tradeStore/index.js